export default __webpack_public_path__ + "static/media/Save.ab5d6304.svg";